// extracted by mini-css-extract-plugin
module.exports = {"headerText":"GreetingUserSkeleton_headerText__1_MHq","row":"GreetingUserSkeleton_row__nzSsX","icon":"GreetingUserSkeleton_icon__jGDyn","text":"GreetingUserSkeleton_text__GJK_N"};